import request from '@/router/axios';

const baseUrl = '/api/produce/emergency-incident';

export const getList = (params) => {
  return request({
    url: `${baseUrl}/approval-page`,
    method: 'post',
    data: params
  });
};

export const getEventDetail = (id) => {
  return request({
    url: `${baseUrl}/detail`,
    method: 'get',
    params: { id }
  });
};

export const submitNext = (data) => {
  return request({
    url: `${baseUrl}/submit-next`,
    method: 'post',
    data
  });
};

export const backIncident = (data) => {
  return request({
    url: `${baseUrl}/back`,
    method: 'post',
    data
  });
};

export const markFalseAlarm = (data) => {
  return request({
    url: `${baseUrl}/false-alarm`,
    method: 'post',
    data
  });
};

export const startPlan = (data) => {
  return request({
    url: `${baseUrl}/start-plan`,
    method: 'post',
    data
  });
};

export const notifySafety = (data) => {
  return request({
    url: `${baseUrl}/notify-safety`,
    method: 'post',
    data
  });
};

export const closeIncident = (data) => {
  return request({
    url: `${baseUrl}/close`,
    method: 'post',
    data
  });
};

export const exportExcel = (params) => {
  return request({
    url: `${baseUrl}/export/excel`,
    method: 'post',
    data: params,
    responseType: 'blob'
  });
};

// 兼容同目录历史子组件的静态引用；当前 y-event 主页面不再使用物资申请/合同选择。
export const supplyAppInsert = (data) => {
  return request({
    url: '/api/produce/emergency-supply-application/insert',
    method: 'post',
    data
  });
};

export const getContractExtpage = (params) => {
  return request({
    url: '/api/produce/transport-contract-ext/select/contractExtpage',
    method: 'get',
    params
  });
};
